import { Search } from "lucide-react";

interface SearchPillProps {
  onClick?: VoidFunction;
  label?: string;
  shortcut?: string;
}

export function SearchPill({
  onClick,
  label = "Search",
  shortcut = "⌘/",
}: SearchPillProps) {
  return (
    <button
      onClick={onClick}
      className="text-content-tertiary bg-surface-subtle hover:border-border hover:bg-surface-muted flex h-7 cursor-pointer items-center gap-2 rounded-full border border-(--border-subtle) px-3 text-sm transition-all duration-150 ease-out"
    >
      <Search className="size-3.5 shrink-0" />
      <span className="whitespace-nowrap">{label}</span>
      <span className="ml-1">{shortcut}</span>
    </button>
  );
}
